export const FORMLY_FIELD_TYPES = {
	accountFilter: 'account-filter',
	accountInput: 'account-input',
	accountRangeTable: 'account-range-table',
	accountPercentageRepeat: 'account-percentage-repeat',
	autocomplete: 'autocomplete',
	accountAutocomplete: 'accountAutocomplete',
	button: 'button',
	checkbox: 'checkbox',
	chipList: 'chip-list',
	datepicker: 'datepicker',
	datepickerRange: 'date-range',
	decimal4Input: 'decimal4-input',
	decimal2Input: 'decimal2-input',
	decimalInput: 'decimal-input',
	deductionGradingTable: 'deduction-grading-table',
	formlyMatButton: 'formly-mat-button',
	formlyMessageList: 'formly-message-list',
	formlyTable: 'formly-table',
	formlyTabs: 'formly-tabs',
	formlyKabab: 'formly-kabab',
	formlySpinner: 'formly-spinner',
	headerLabel: 'header-label',
	imagePreview: 'image-preview',
	input: 'input',
	inputPositiveIntegers: 'positive-integers-input',
	maskedInput: 'masked-input',
	micrInput: 'micr-input',
	multiCheckbox: 'multi-checkbox',
	multiSelectAll: 'multiselect-all',
	multiSelectAutocomplete: 'multiselect-autocomplete',
	multiuseSearchInput: 'multiuse-search-input',
	multiSelectChips: 'multiselect-chips',
	negativeDecimal2Input: 'negative-decimal2-input',
	percentageInput: 'percentage-input',
	plainText: 'plaintext-input',
	prGradingTable: 'pr-grading-table',
	radio: 'radio',
	repeat: 'repeat',
	select: 'select',
	selectSearch: 'select-search',
	ssnInput: 'ssn-input',
	template: 'template',
	textarea: 'textarea',
	timePicker: 'time-picker',
	toggle: 'toggle-input',
	tooltip: 'tooltip',
	uibDropdown: 'uib-dropdown',
	vendorAutocomplete: 'vendor-autocomplete',
	verticalSpacer: 'vertical-spacer',
	zipInput: 'zip-input',
	elementRange: 'element-range',
	appDatepicker: 'app-datepicker',
	appSelectModal: 'app-select-modal',
	formGroupRepeat: 'form-group-repeat',
	roleSectionPermissions: 'role-section-permissions',
	roleFieldClaims: 'role-field-claims',
};
